export default function getPaymentRedirectNotice(gateway) {
    switch (gateway?.type) {
        case 'paypal':
            return 'REDIRECT_FORM_PAYPAL_REDIRECT_NOTICE';
        case 'sepa':
            return 'NEW_CHECKOUT_REDIRECT_FORM_SEPA_TEXT';
        default:
            return 'REDIRECT_FORM_REDIRECT_NOTICE';
    }
}
